import { fetchMFAPreference, fetchUserAttributes } from 'aws-amplify/auth';

export type MfaSetupStatus = {
  hasVerifiedPhoneNumber: boolean;
  hasSmsMfaEnabled: boolean;
  setupRequired: boolean;
};

const SMS_MFA_METHOD = 'SMS';

export const getCurrentMfaSetupStatus = async (): Promise<MfaSetupStatus> => {
  const [{ enabled, preferred }, attributes] = await Promise.all([
    fetchMFAPreference(),
    fetchUserAttributes(),
  ]);

  const hasVerifiedPhoneNumber = attributes.phone_number_verified === 'true';
  const hasSmsMfaEnabled =
    preferred === SMS_MFA_METHOD || enabled?.includes(SMS_MFA_METHOD) === true;

  return {
    hasVerifiedPhoneNumber,
    hasSmsMfaEnabled,
    setupRequired: !hasVerifiedPhoneNumber || !hasSmsMfaEnabled,
  };
};
